export default {
  methods: {
    getValue(string) {
      if (!!this.prefix) return this[this.prefix][string]
      else return this[string]
    }
  },
  computed: {

    tipObj() {
      var tipId = this.getValue('tipId')
      if (!!tipId) {
        return this.getObjByPrimaryId(tipId, this.tips)
      } else {
        return null
      }
    },
    spoilObj() {
      var spoilId = this.getValue('spoilId')
      if (!!spoilId) {
        return this.getObjByPrimaryId(spoilId, this.spoils)
      } else {
        return null
      }
    },
    tippingDocketRequired() {
      if (this.tipObj) {
        return this.tipObj.tippingDocketRequired
      } else {
        return false
      }
    },
    tippingDocketRequiredHint() {
      if (this.tippingDocketRequired) {
        return "<div class='indigo--text'>" + this.tipObj.name + " requires a tipping docket</div>"
      }
    },
    // rateType() {
    //     var rateType = "Standard"

    //     if(this.useNightRate) { 
    //         rateType = "Night"
    //     } else if(this.useAltRate) { 
    //         rateType = "Alt. Hourly"
    //     }
    //     if(this.date) {
    //         var docketDate = new Date(this.date);
    //         if(docketDate.getDay() == 0) { 
    //             rateType = "Sunday"
    //             if(!!this.useAltRate) { 
    //                 rateType = "Sunday+Alt"
    //             }
    //         }
    //     }


    // }
  }
}